/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-param-reassign */

/**
 * DialogConfirm is a direct copy from https://www.npmjs.com/package/vuetify-confirm
 * It was modified to be able to customise it, and the decision to copy it was made based
 * on the fact that it is a small component, and it is not likely to receive new features.
 * Documentation is available at https://www.npmjs.com/package/vuetify-confirm
 */

import Confirm from "./ConfirmDialog.vue";

function install(Vue: any, options: any = {}) {
  const propertyAlias = "$confirm"; // options.propertyAlias || "$confirm";
  delete options.propertyAlias;
  const { vuetify } = options;
  delete options.vuetify;
  // if (!vuetify) {
  //   console.warn("Module confirm-dialog needs vuetify instance. Use Vue.use(ConfirmDialog, { vuetify })");
  // }

  function createDialogCmp(_options: any) {
    const Ctor = Vue.extend({ vuetify, ...Confirm });
    const container = document.querySelector("[data-app=true]") || document.body;

    return new Promise((resolve) => {
      const cmp = new Ctor({
        propsData: { ...Vue.prototype[propertyAlias].options, ..._options },
        destroyed: () => {
          container.removeChild(cmp.$el);
          resolve(cmp.value);
        },
      });
      container.appendChild(cmp.$mount().$el);
    });
  }

  function show(message: any, _options: any = {}) {
    _options.message = message;
    return createDialogCmp(_options);
  }

  Vue.prototype[propertyAlias] = show;
  Vue.prototype[propertyAlias].options = options || {};
}

export default install;

if (typeof window !== "undefined" && window.Vue) {
  window.Vue.use(install);
}
